import React from "react";

// Minimalist alpine ridgeline SVG. Used as section divider and footer accent.
// `fill` defines the ridge color (usually the next section background).
// `bg` defines the background block (usually the previous section background).
export default function MountainRidge({
  fill = "#F7F9FB",
  bg = "transparent",
  flip = false,
  className = "",
  accent = "#6FB04F",
}) {
  return (
    <div
      className={`w-full overflow-hidden leading-[0] ${className}`}
      style={{ background: bg, transform: flip ? "scaleY(-1)" : "none" }}
      data-testid="mountain-ridge"
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
        className="block h-[60px] w-full sm:h-[90px] lg:h-[120px]"
      >
        {/* Back ridge (sage, subtle) */}
        <path
          d="M0,90 L140,55 L260,80 L380,45 L520,75 L640,40 L780,72 L900,38 L1040,68 L1180,42 L1300,72 L1440,55 L1440,120 L0,120 Z"
          fill={accent}
          opacity="0.35"
        />
        {/* Front ridge */}
        <path
          d="M0,100 L120,72 L220,95 L340,60 L460,90 L580,55 L700,88 L820,50 L960,85 L1080,62 L1220,92 L1340,70 L1440,95 L1440,120 L0,120 Z"
          fill={fill}
        />
      </svg>
    </div>
  );
}
